import { render, staticRenderFns } from "./ObiPortalGeneralTab.vue?vue&type=template&id=960db6b8&scoped=true&"
import script from "./ObiPortalGeneralTab.vue?vue&type=script&lang=js&"
export * from "./ObiPortalGeneralTab.vue?vue&type=script&lang=js&"
import style0 from "./ObiPortalGeneralTab.vue?vue&type=style&index=0&id=960db6b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960db6b8",
  null
  
)

export default component.exports